import type Big from 'big.js';

import { toBig } from '@cast/utils';

/**
 * Safely divides two numbers using Big.js, returning 0 if denominator is zero or negative
 */
export const safeDivide = (
  numerator: number | Big,
  denominator: number | Big
): number => {
  const denomValue = toBig(denominator);
  return denomValue.gt(0) ? toBig(numerator).div(denomValue).toNumber() : 0;
};
